// extracted by mini-css-extract-plugin
export var alternate = "_u-j";
export var black = "_u-6";
export var blue = "_u-f";
export var blueLight = "_u-e";
export var brand = "_u-8";
export var darkMode = "_u-b";
export var error = "_u-a";
export var gray = "_u-5";
export var grayBlue = "_u-d";
export var iconWrapper = "_u-3";
export var inactive = "_u-7";
export var indigo = "_u-g";
export var orange = "_u-i";
export var pink = "_u-h";
export var primary = "_u-0";
export var purple = "_u-9";
export var success = "_u-4";
export var warning = "_u-c";
export var white = "_u-1";
export var whiteSuccess = "_u-2";